import "core-js/modules/es.array.push.js";
import axios from 'axios';
import Bus from '@/assets/js/bus.js';
import Tool, { handleLocalStorage, returnSourceType, getFullscreenEnabled, routerJump } from '@/assets/js/utils.js';
import AgoraClient from '@/assets/js/rtc-client-ng';
import { mapState } from 'vuex';
import { controlCamera, controlAudio, changeBehaviorStatus, controlDeviceBehavior, controlDevicePublish, controlDeviceAudioOrVideo } from '@/assets/js/attendUser.js';
const nodeUrl = require('url');
export default {
  computed: {
    ...mapState({
      State: state => state,
      nickNameMap: state => state.nickNameMap,
      loginInfo: state => state.loginInfo
    })
  },
  components: {},
  data() {
    var _JSON$parse;
    return {
      hostConnections: {},
      // 存储host与每个pip的私聊状态
      privateChatList: [],
      // 存储所有私聊状态
      activeConnections: {},
      // 存储pip之间的私聊状态
      iconList: ['mic', 'speaker'],
      rtilCode: '',
      isNotLoginArray: [],
      devicePeerId: {},
      unitWidth: '',
      communicateBodyHeight: '',
      communicate: true,
      wsPageSTimer: null,
      socket: null,
      rtilStatusObj: {},
      livePeerMap: {},
      outputRtilCode: '',
      degreeHost: {},
      devicePeerIdInfo: {},
      allRtilList: [],
      rtilCodeList: [],
      allRtilCodeByAccountId: {},
      allAccountIdByRtilCode: {},
      sourceIdList: [],
      sourceIdKeyList: [],
      rtilCodeKeyTypeVal: {},
      otherMediaInfo: {},
      allRList: {},
      deviceStatusObj: {},
      remoteNetWorks: {},
      userInfo: {},
      voipInfo: {},
      fullScreenInfo: {},
      voiceList: {},
      tagNameInfo: {},
      avatarInfo: {},
      devicePlatform: {},
      bookLiveInfos: {},
      audioLevel: true,
      env: handleLocalStorage('get', 'partylineConfig') ? (_JSON$parse = JSON.parse(handleLocalStorage('get', 'partylineConfig'))) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.apiEnv : '',
      rtilCodeLiveR: {},
      behaviorInfo: {},
      partyCode: 0,
      communicationUnits: [{
        slotNum: 1,
        connectedTo: [2, 3, 4]
      }, {
        slotNum: 2,
        connectedTo: [1, 3, 4]
      }, {
        slotNum: 3,
        connectedTo: [1, 2, 4]
      }, {
        slotNum: 4,
        connectedTo: [1, 2, 3]
      }],
      audioEnabled: true,
      videoEnabled: true,
      mic: true,
      speaker: true,
      partyInfo: {},
      talentSearch: '',
      talentList: [],
      allTalentList: [],
      // 用来在没有搜索时恢复全部显示
      stationList: [],
      allStationList: [],
      // 用来在没有搜索时恢复全部显示
      stationTimer: null,
      sessionList: [],
      rtc: null,
      rtcLoaded: false,
      channels: {},
      deviceType: {},
      devicesInfo: {},
      selectSessionInfo: {},
      noSessionSelectTalents: [],
      noSessionSelectStations: [],
      activeSpeakerInfo: {},
      repeatInfo: {
        show: false,
        title: 'common.repeatJoin',
        save: 'authorizeOperation.ok'
      },
      controlActiveTime: 0,
      selectStationInfo: [],
      allRtilCode: [],
      movePartyInfo: {}
    };
  },
  mounted() {
    this.changeLayout();
    this.communicationUnits.forEach(unit => {
      this.$set(this.activeConnections, unit.slotNum, []);
    });
  },
  async created() {
    window.addEventListener('resize', this.changeLayout);
    // 获取并校验 partyCode
    const URL = nodeUrl.parse(location.href, true);
    this.partyCode = URL.query.id || '761012963271';
    // 检查 partyCode 中是否包含字母
    const hasLetters = /[a-zA-Z]/.test(this.partyCode);
    const illegalPartyCode = hasLetters ? this.partyCode : '';
    if (this.partyCode) this.partyCode = this.partyCode.replace(/[^0-9]/ig, ''); // 过滤掉非数字字符
    if (!this.partyCode || this.partyCode.length > 20 || this.partyCode.length < 9) {
      this.$message.error(this.$t('common.invalidPartyIdText'));
      return;
    }
    this.getPartyInfo(this.partyCode, illegalPartyCode);
    this.getRList();
    Bus.$on('leaveParty', async v => {
      var _this$activeConnectio;
      const {
        slotNum,
        rtilCode
      } = v;
      // 清除host与该pip私聊状态
      if (this.hostConnections[slotNum]) {
        this.handlePrivateConversation('cancelPrivateConversation', this.userInfo.rtilCode, rtilCode, false, slotNum);
      }

      // 清除该pip与其他pip的私聊状态
      if (((_this$activeConnectio = this.activeConnections[slotNum]) === null || _this$activeConnectio === void 0 ? void 0 : _this$activeConnectio.length) != 0) {
        const clearRtilCodeMap = {};
        this.privateChatList && this.privateChatList.forEach(item => {
          const startRtilCode = Number(item.remark);
          const receiveRtilCode = Number(item.subKey);
          if (startRtilCode == this.userInfo.rtilCode) return;
          // 如果从状态接口拿到的数据刚好与操作的两个数据相等且相反，则需要将其反转传参
          if (startRtilCode == rtilCode || receiveRtilCode == rtilCode) {
            clearRtilCodeMap[startRtilCode] = receiveRtilCode;
          }
        });
        this.clearPrivateConversationList(clearRtilCodeMap, slotNum, rtilCode);
      }
    });
    Bus.$on('controlBehavior', async v => {
      const {
        rtilCode,
        behavior
      } = v;
      const {
        key,
        value
      } = behavior;
      if (key == 'nickName' && this.behaviorInfo[rtilCode]) {
        this.behaviorInfo[rtilCode] = value;
        // firstName获取不到，说明未登录头像要跟nickName着变化
        const _rtilCode = rtilCode + '';
        if (this.isNotLoginArray.includes(_rtilCode)) {
          this.avatarInfo[rtilCode] = value;
        }
      }
    });
    Bus.$on('removeParticipant', v => {
      this.communicationUnits.forEach(item => {
        if (item.mainWindowRtilCode == v.rtilCode) {
          item.mainWindowRtilCode = '';
        }
      });
    });
    Bus.$on('endParty', v => {
      routerJump('remove', {
        type: 'end'
      });
    });
    // 获取rtil对应的R的状态
    Bus.$off('pageSerBusCallback');
    Bus.$on('pageSerBusCallback', v => {
      if (v.partyCode != this.partyCode) return;
      this.pageSerBusCallback(v);
    });
    Bus.$on('rtilLiveStatus', v => {
      this.rtilStatusObj = v;
      // 处理R作为与会者加入会议 将其作为rtil状态
      Object.keys(this.deviceType).forEach(itemVal => {
        Object.keys(v).forEach(item => {
          if (item == itemVal) {
            this.rtilStatusObj[item] = {
              ...v[item],
              channel: this.partyCode,
              type: this.deviceType[item]
            };
          }
        });
      });
    });
    Bus.$off('setOutput');
    Bus.$on('setOutput', v => {
      this.communicationUnits.map(item => {
        if (item.slotNum == v.slotNum) {
          item.mainWindowRtilCode = v.rtilCode;
        }
      });
    });
    Bus.$on('cancelOutput', v => {
      this.$set(this.devicePeerId, v.rtilCode, '');
      this.communicationUnits.map(item => {
        if (item.slotNum == v.slotNum) {
          item.mainWindowRtilCode = '';
        }
      });
    });
    Bus.$on('flipVideo', v => {
      this.$set(this.degreeHost, v.rtilCode, v.degree);
    });
    Bus.$on('viewPositionV2', result => {
      const rtilCodes = result.total;
      this.allRtilList = rtilCodes;
      this.handleRtilCodeList();
      rtilCodes.forEach(rtilCode => {
        const haveName = this.behaviorInfo[rtilCode];
        if (!haveName) {
          this.getNickName(rtilCode);
        }
      });
    });
    Bus.$on('refreshSourceStatus', v => {
      v.forEach(item => {
        if (item.livePeerName && item.status == 2) {
          if (item.type == 'T') {
            this.livePeerMap[this.devicePeerIdInfo[item.peerId]] = {
              ...item,
              channel: this.partyCode // 添加额外的channel字段
            };
          }
        }

        if (!item.livePeerName && item.status != 2) {
          this.livePeerMap && Object.keys(this.livePeerMap).forEach(key => {
            if (item.peerId == this.livePeerMap[key].peerId) {
              delete this.livePeerMap[key];
            }
          });
        }
        this.deviceStatusObj = this.livePeerMap;
      });
    });
    Bus.$on('volumeList', volumeList => {
      volumeList.forEach(volume => {
        this.$set(this.voiceList, volume.uid, volume);
      });
    });
    Bus.$on('responseControlBehavior', v => {
      const {
        key,
        rtilCode,
        responseCode,
        senderRtilCode
      } = v;
      if (rtilCode == this.userInfo.rtilCode || rtilCode == -1) {
        if (key === 'camera') {
          if (responseCode == 2) {
            this.$set(this.State.cameraStatus, senderRtilCode, false);
            this.$message.warning(this.$t('kioskHost.requestDeny'));
          }
          if (responseCode == 3) {
            this.$message.warning(this.$t('common.operationCameraFailed'));
          }
        }
        if (key == 'mic') {
          if (responseCode == 3) {
            this.$message.warning(this.$t('common.operationMicroFailed'));
          }
        }
      }
    });
    Bus.$on('setBehaviors', val => {
      const behaviors = val.behaviors;
      behaviors.forEach(item => {
        const {
          key,
          mark,
          value
        } = item;
        if (key == 'nickName') {
          this.$set(this.behaviorInfo, mark, value);
          // firstName获取不到，说明未登录头像要跟nickName着变化
          if (this.isNotLoginArray.includes(mark)) {
            this.$set(this.avatarInfo, mark, value);
          }
        }
        if (key === 'addIntercomProDeviceRtilCode') {
          this.getDeviceDatailByRtilCode({
            id: mark,
            channel: this.partyInfo.joinCode
          });
        }
      });
    });
    Bus.$on('setLoginScreenButton', async val => {
      const {
        buttonType,
        operationType
      } = val.buttonStatus;
      if (buttonType === 17) {
        if (operationType === 0) {
          this.audioLevel = true;
          this.$message.success(this.$t('remainWords.hostChangeAudioLevel'));
        } else {
          this.audioLevel = false;
          this.$message.success(this.$t('remainWords.hostChangeAudioBar'));
        }
      }
    });
    this.createdWebsocket(this.State.config);
  },
  methods: {
    setBookLive(obj) {
      this.$set(this.bookLiveInfos, obj.slotNum, obj);
    },
    getBookLive() {
      if (!this.partyCode) return;
      const params = {
        annotation: this.partyCode,
        key: 'interviewSlotAutoLive'
      };
      this.axios.post('/partyline-backend/userkkv/noLogin/getPartyCodeKey', params).then(async res => {
        if (res.data.errorCode == '0x0') {
          const result = res.data.result;
          result.forEach(item => {
            const parsedValue = item.remark ? JSON.parse(item === null || item === void 0 ? void 0 : item.remark) : {};
            this.$set(this.bookLiveInfos, item.mark, parsedValue);
          });
        }
      });
    },
    hasParticipantRtilCode(targetSlot, currentSlot) {
      const targetUnit = this.communicationUnits.find(u => u.slotNum === targetSlot);
      const currentUnit = this.communicationUnits.find(u => u.slotNum === currentSlot);
      return this.isSlotActive(currentSlot, targetSlot) || targetUnit && targetUnit.participantRtilCode && currentUnit && currentUnit.participantRtilCode;
    },
    initHostActiveConnections() {
      // 初始化host与pip的私聊状态
      this.privateChatList && this.privateChatList.forEach(item => {
        const startRtilCode = Number(item.mark);
        const receiveRtilCode = Number(item.subKey);

        // 如果是host发起的私聊
        if (startRtilCode === this.userInfo.rtilCode) {
          // 找到接收者对应的slot
          const targetUnit = this.communicationUnits.find(unit => unit.participantRtilCode === receiveRtilCode);
          if (targetUnit) {
            this.$set(this.hostConnections, targetUnit.slotNum, true);
          }
        }
      });
    },
    initActiveConnections() {
      // 重置所有pip之间私聊状态
      this.communicationUnits.forEach(unit => {
        this.$set(this.activeConnections, unit.slotNum, []);
      });

      // 处理私聊列表数据
      this.privateChatList && this.privateChatList.forEach(item => {
        const startRtilCode = Number(item.mark);
        const receiveRtilCode = Number(item.subKey);

        // 查找对应的slot
        const startUnit = this.communicationUnits.find(unit => unit.participantRtilCode === startRtilCode);
        const receiveUnit = this.communicationUnits.find(unit => unit.participantRtilCode === receiveRtilCode);
        if (startUnit && receiveUnit) {
          const startSlot = startUnit.slotNum;
          const receiveSlot = receiveUnit.slotNum;

          // 添加双向私聊
          if (!this.activeConnections[startSlot].includes(receiveSlot)) {
            this.activeConnections[startSlot].push(receiveSlot);
          }
          if (!this.activeConnections[receiveSlot].includes(startSlot)) {
            this.activeConnections[receiveSlot].push(startSlot);
          }
        }
      });

      // 确保UI更新
      Object.keys(this.activeConnections).forEach(slotNum => {
        this.$set(this.activeConnections, slotNum, [...this.activeConnections[slotNum]]);
      });
    },
    getAllPrivate() {
      if (!this.partyCode) return;
      const params = {
        annotation: this.partyCode,
        key: 'privateChat',
        value: true
      };
      this.axios.post('/partyline-backend/userkkv/noLogin/getPartyCodeKey', params).then(async res => {
        if (!res) return;
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          this.privateChatList = result;
        }
      });
    },
    isSlotActive(currentSlot, targetSlot) {
      var _this$activeConnectio2;
      return (_this$activeConnectio2 = this.activeConnections[currentSlot]) === null || _this$activeConnectio2 === void 0 ? void 0 : _this$activeConnectio2.includes(targetSlot);
    },
    // 与会者离开批量清除私聊逻辑
    clearPrivateConversationList(clearRtilCodeMap, slotNum, rtilCode) {
      const params = {
        partyCode: this.partyCode,
        rtilCode: this.userInfo.rtilCode,
        clearRtilCodeMap
      };
      this.axios.post('/partyline-backend/intercom/noLogin/clear', params).then(res => {
        if (res.data.errorCode === '0x0') {
          Object.keys(this.activeConnections).forEach(value => {
            if (this.activeConnections[value].includes(slotNum)) {
              // 清除跟这个人私聊的slot的状态
              this.activeConnections[value] = this.activeConnections[value].filter(item => item !== slotNum);
            }
          });
          // 清除自己slot下面自己的pip状态
          this.$set(this.activeConnections, slotNum, []);
          this.privateChatList = this.privateChatList.filter(item => !(item.mark == rtilCode || item.subKey == rtilCode));
        }
      }).catch(error => {
        console.error('Private conversation error:', error);
      });
    },
    handlePrivateConversation(type, startRtilCode, receiveRtilCode, value, slotNum) {
      const params = {
        partyCode: this.partyCode,
        rtilCode: startRtilCode,
        startRtilCode,
        receiveRtilCode,
        msg: {
          ack: 0
        },
        value
      };
      this.axios.post('/partyline-backend/intercom/noLogin/i', params).then(res => {
        if (res.data.errorCode === '0x0') {
          if (type == 'startPrivateConversation') {
            this.privateChatList.push({
              mark: startRtilCode.toString(),
              subKey: receiveRtilCode.toString(),
              remark: startRtilCode.toString()
            });
            startRtilCode == this.userInfo.rtilCode ? this.$message.success(this.$t('commonPartyHost.sendPrivate')) : this.$message.success(this.$t('commonPartyHost.turnOnIntercommunicate'));
          } else {
            this.privateChatList = this.privateChatList.filter(item => !(item.mark === startRtilCode.toString() && item.subKey === receiveRtilCode.toString()));
            // 与会者离开清除与host私聊
            if (slotNum) {
              this.$set(this.hostConnections, slotNum, false);
            }
            startRtilCode == this.userInfo.rtilCode ? this.$message.success(this.$t('commonPartyHost.endPrivate')) : this.$message.success(this.$t('commonPartyHost.turnOffIntercommunicate'));
          }
        }
      }).catch(error => {
        console.error('Private conversation error:', error);
      });
    },
    // host 控制 pip 之间
    toggleConnection(currentSlot, targetSlot) {
      if (currentSlot === targetSlot) return;
      const currentConnections = [...(this.activeConnections[currentSlot] || [])];
      const targetConnections = [...(this.activeConnections[targetSlot] || [])];
      const isActive = currentConnections.includes(targetSlot);

      // 获取发送pip和接收pip的participantRtilCode
      const currentUnit = this.communicationUnits.find(u => u.slotNum === currentSlot);
      const targetUnit = this.communicationUnits.find(u => u.slotNum === targetSlot);
      if (!currentUnit || !targetUnit) {
        console.error('Could not find communication units', {
          currentSlot,
          targetSlot
        });
        return;
      }
      let sourceRtilCode = currentUnit.participantRtilCode;
      let targetRtilCode = targetUnit.participantRtilCode;
      if (!sourceRtilCode || !targetRtilCode) {
        return;
      }
      if (isActive) {
        // 从当前单元移除目标单元
        this.activeConnections[currentSlot] = currentConnections.filter(slot => slot !== targetSlot);
        // 从目标单元移除当前单元
        this.activeConnections[targetSlot] = targetConnections.filter(slot => slot !== currentSlot);
        // 确保UI更新
        this.$set(this.activeConnections, currentSlot, [...this.activeConnections[currentSlot]]);
        this.$set(this.activeConnections, targetSlot, [...this.activeConnections[targetSlot]]);
        this.privateChatList && this.privateChatList.forEach(item => {
          // 接口存储状态
          const startRtilCode = Number(item.remark);
          const receiveRtilCode = Number(item.subKey);
          // 如果从状态接口拿到的数据刚好与操作的两个数据相等且相反，则需要将其反转传参
          if (targetRtilCode == startRtilCode && sourceRtilCode == receiveRtilCode) {
            sourceRtilCode = startRtilCode;
            targetRtilCode = receiveRtilCode;
          }
        });
        this.handlePrivateConversation('cancelPrivateConversation', sourceRtilCode, targetRtilCode, false);
      } else {
        // 添加连接时
        // 更新当前单元的连接状态
        this.activeConnections[currentSlot] = [...currentConnections, targetSlot];
        // 在UI上点亮目标单元中的当前单元连接
        this.activeConnections[targetSlot] = [...targetConnections, currentSlot];
        // 确保UI更新
        this.$set(this.activeConnections, currentSlot, [...this.activeConnections[currentSlot]]);
        this.$set(this.activeConnections, targetSlot, [...this.activeConnections[targetSlot]]);
        // 添加连接
        this.handlePrivateConversation('startPrivateConversation', sourceRtilCode, targetRtilCode, true);
      }
    },
    hostCommunicate(item) {
      if (!item.participantRtilCode) {
        return;
      }
      const newValue = !this.hostConnections[item.slotNum];
      this.$set(this.hostConnections, item.slotNum, newValue);
      this.handlePrivateConversation(newValue ? 'startPrivateConversation' : 'cancelPrivateConversation', this.userInfo.rtilCode, item.participantRtilCode, newValue);
    },
    changeMute(flag) {
      this.$store.commit('isMute', !this.State.isMute);
      if (flag) {
        this.$message({
          type: 'success',
          message: this.$t('galleryParticipant.websiteSoundOff')
        });
      } else {
        this.$message({
          type: 'success',
          message: this.$t('galleryParticipant.websiteSoundOn')
        });
      }
      // 判断是否需要恢复声音
      if (this.startHearSelf && this.hearSelf && this.userInfo.rtilCode && this.State.micStatus[this.userInfo.rtilCode] && !this.State.isMute) {
        this.rtc && this.rtc.play(this.rtc._localAudioTrack, '', {
          type: 'audio'
        });
      }
      changeBehaviorStatus({
        key: 'speaker',
        rtilCode: this.userInfo.rtilCode,
        realPartyCode: this.userInfo.realPartyCode,
        value: !this.State.isMute
      });
    },
    async dealFootEvent(info) {
      const {
        type,
        val
      } = info;
      switch (type) {
        case 'muteAudio':
          if (!this.rtcLoaded) return;
          if (this.osLevelmicMuted && !val) {
            this.showMicMutedInfo.show = true;
            return;
          }
          let operationResult = 'success';
          let time = 0;
          if (this.rtc._localAudioTrack) {
            const type = val ? 'publish' : 'unpublish';
            time = new Date().getTime();
            console.log('time', time);
            operationResult = await controlDevicePublish(this.rtc, type, [this.rtc._localAudioTrack]);
          } else {
            // 初始化的时候没有本地音频轨道，需要重新获取
            controlAudio(this.rtc, this.devicesInfo, val, result => {
              if (result == 'failed') operationResult = 'failed';
            });
          }
          if (operationResult === 'success') {
            controlDeviceBehavior({
              senderRtilCode: this.userInfo.rtilCode,
              type: 'mic',
              value: val,
              partyCode: this.userInfo.realPartyCode,
              toRtilCode: this.userInfo.rtilCode,
              origin: 'commonPartyHost',
              notChangeStatus: true
            });
            console.log('time', new Date().getTime() - time);
            // 恢复听自己声音功能
            if (val && this.hearSelf && this.userInfo.rtilCode && this.State.micStatus[this.userInfo.rtilCode] && !this.State.isMute) {
              this.rtc && this.rtc.play(this.rtc._localAudioTrack, '', {
                type: 'audio'
              });
            }
          }
          break;
        case 'changeDevice':
          this.switchDevice(val);
          break;
        case 'changeMute':
          this.changeMute(val);
          break;
      }
    },
    changeLayout() {
      var _this$$refs$interview;
      const videoCanvasHeight = (_this$$refs$interview = this.$refs.interviewBox) === null || _this$$refs$interview === void 0 ? void 0 : _this$$refs$interview.clientHeight;
      this.communicateBodyHeight = videoCanvasHeight - 40 - 80 + 'px';
    },
    urlAddress(slotNum) {
      const domain = window.location.host;
      this.showIt = window.location.href.includes('control') || this.$route.name === 'party';
      return 'https://' + domain + '/partyline?join_id=' + this.partyCode + `${this.env ? '&env=' + this.env : ''}` + `${slotNum ? '&slotNum=' + slotNum : ''}`;
    },
    pageSerBusCallback({
      socket,
      partyCode
    }) {
      this.wsPageSTimer = setInterval(() => {
        let rtilCodes = Object.keys(this.allAccountIdByRtilCode);
        rtilCodes = rtilCodes.filter(item => item != this.rtilCode);
        if (this.$route.name != 'interview') clearInterval(this.wsPageSTimer);
        if (rtilCodes.length == 0) return;
        // 发送liveRtilCodes
        const params = {
          data: JSON.stringify({
            data: JSON.stringify({
              rtilCodes: rtilCodes,
              businessId: partyCode
            }),
            module: 'rtilLiveStatus',
            type: 'rtilLiveStatus'
          }),
          serverName: 'partyline'
        };
        if (socket.client.readyState === 1 && this.$route.name == 'interview') {
          socket.send(params);
        }
      }, 1000);
    },
    createdWebsocket(addressInfo) {
      const [taskId] = [Tool.return32Str()];
      if (!addressInfo.urlInfo) return;
      const url = 'wss://' + addressInfo.urlInfo.ccWebsocket + '/pageRequest?taskId=' + taskId;
      const _self = this;
      this.socket = Tool.createWs(url);
      this.updataInfoTimer = setInterval(() => {
        if (_self.socket.client.readyState === 1) {
          const params = {
            type: 'listCurrentDevice',
            module: 'listCurrentDevice',
            data: {
              peerIds: _self.sourceIdList.join(',')
            }
          };
          _self.socket.send(params);
        }
      }, 1000);
    },
    userLeave(payload) {
      this.State.haveUnReadMessage = true;
      const {
        id
      } = payload;
      this.communicationUnits.forEach(item => {
        if (item.participantRtilCode == id) {
          item.participantRtilCode = '';
        }
      });
      this.$delete(this.rtilCodeKeyTypeVal, id);
      if (this.State.localShareInfo[id]) this.$delete(this.State.localShareInfo, id);
      if (id == this.outputRtilCode) {
        this.State.pgmStream = null;
        this.origin = '';
        this.outputRtilCode = '';
        this.handleRtilCodeList();
      }
      if (payload.id == this.leftRightShareRtilCode) {
        this.leftRightShareRtilCode = '';
        this.State.commonHostLeftRight = false;
      }
      if (payload.id == this.leftRightRtilCode) {
        this.leftRightRtilCode = '';
        this.State.commonHostLeftRight = false;
      }
      if (this.fullScreenInfo[payload.id]) {
        this.$set(this.fullScreenInfo, id, false);
        this.State.fullScreen = false;
        if (document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement) {
          document.exitFullscreen();
        }
      }
      this.State.v3List.forEach((item, index) => {
        if (item.rtilCode == payload.id && item.type === 'T') {
          this.State.v3List.splice(index, 1);
        }
      });
      this.$set(this.channels, id, {
        id
      });
      this.$delete(this.State.deviceInfo, id);
      this.$delete(this.allAccountIdByRtilCode, id);
      this.State.allRtilCodes = this.State.allRtilCodes.filter(v => v != payload.id);
      // 更新所有可以moveParty的rtilCode
      this.State.batchMoveParticipateList = this.State.batchMoveParticipateList.filter(v => v != payload.id);
    },
    canSaveToGlobal(type, id) {
      let flag = true;
      if (type == 'R' || type == 'T' || this.sttRtilCode == id || this.outputRtilCode && this.outputRtilCode == id || this.State.allRtilCodes.includes(id)) {
        flag = false;
      }
      return flag;
    },
    detecteMicMuted() {
      var _this$rtc, _this$rtc$_localAudio;
      const mediaStream = (_this$rtc = this.rtc) === null || _this$rtc === void 0 ? void 0 : (_this$rtc$_localAudio = _this$rtc._localAudioTrack) === null || _this$rtc$_localAudio === void 0 ? void 0 : _this$rtc$_localAudio._mediaStreamTrack;
      if (!mediaStream) return;
      this.osLevelmicMuted = mediaStream.muted;
      mediaStream.onmute = () => {
        this.osLevelmicMuted = true;
      };
      mediaStream.onunmute = () => {
        this.osLevelmicMuted = false;
      };
    },
    muteAudioOrVideo(action, payload) {
      const {
        id
      } = payload;
      if (action === 'user-unpublished') {
        if (payload.mediaType === 'video') {
          this.$set(this.State.cameraStatus, id, false);
        } else {
          this.$set(this.State.micStatus, id, false);
        }
      } else {
        if (payload.mediaType === 'video') {
          this.$set(this.State.cameraStatus, id, true);
        } else {
          this.$set(this.State.micStatus, id, true);
        }
      }
    },
    userPublished(action, payload) {
      this.muteAudioOrVideo(action, payload);
      const {
        id,
        mediaType
      } = payload;
      const val = action === 'user-published';
      mediaType === 'video' ? this.$set(this.State.cameraStatus, id, val) : this.$set(this.State.micStatus, id, val);
      if (action == 'user-unpublished' && mediaType == 'video') {
        this.$set(this.channels, id, {
          ...this.channels[id],
          videoTrack: null
        });
      }
    },
    dealSubscribeVideo(payload) {
      const _this = this;
      const {
        id
      } = payload;
      // 因为还没有后面赋值所以先添加上
      if (!this.channels[id]) {
        this.$set(this.channels, id, {
          id: id,
          channel: this.partyCode
        });
      }
      const pinnCode = this.outputRtilCode || this.leftRightRtilCode;
      if (pinnCode && pinnCode == id) {
        // 先判断当前 audio-only 选择的模式
        if (this.State.audioType) {
          if (this.State.checkMainWindow || this.State.audioType == 2) {
            var _this$rtc2;
            this.channels[id].hasUnsubscribe = false;
            (_this$rtc2 = this.rtc) === null || _this$rtc2 === void 0 ? void 0 : _this$rtc2.subscribe(id, 'video', 'unExecuteCallback');
          } else {
            this.channels[id].hasUnsubscribe = true;
          }
        } else {
          if (this.State.inAudioOnlyStatus) {
            if (this.State.checkMainWindow) {
              var _this$rtc3;
              this.channels[id].hasUnsubscribe = false;
              (_this$rtc3 = this.rtc) === null || _this$rtc3 === void 0 ? void 0 : _this$rtc3.subscribe(id, 'video', 'unExecuteCallback');
            } else {
              this.channels[id].hasUnsubscribe = true;
            }
          } else {
            var _this$rtc4;
            this.channels[id].hasUnsubscribe = false;
            (_this$rtc4 = this.rtc) === null || _this$rtc4 === void 0 ? void 0 : _this$rtc4.subscribe(id, 'video', 'unExecuteCallback');
          }
        }
      } else {
        if (this.State.audioType == 1) {
          _this.channels[id].hasUnsubscribe = true;
        } else {
          var _this$rtc5;
          (_this$rtc5 = this.rtc) === null || _this$rtc5 === void 0 ? void 0 : _this$rtc5.subscribe(id, 'video', 'unExecuteCallback');
          this.channels[id].hasUnsubscribe = false;
        }
      }
    },
    sendToGetMediaInfo(id) {
      const params = {
        partyCode: this.State.partyCode,
        module: 'notify',
        msg: {
          key: 'getMediaInfo',
          rtilCode: id,
          origin: 'host'
        }
      };
      this.axios.post('/partyline-backend/party/noLogin/command?key=27994', params).then(async res => {});
    },
    openliveAndLazyAudio(value) {
      if (value) {
        this.starting = true;
        if (this.talkbackStatus) {
          this.liveAndLazyAudioInfo.show = true;
        }
      } else {
        this.starting = false;
      }
    },
    changeAllRList(list) {
      this.allRList = list;
    },
    getRList() {
      const params = {
        pageNum: 1,
        pageSize: 400,
        living: true,
        offline: false,
        online: true,
        queryCollaborate: true
      };
      this.axios.post('/partyline-backend/receiver/v3/page', params).then(res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result;
          this.allRList = result;
          if (this.allRList.pps && this.allRList.pps[0]) {
            this.State.ppRlist = this.allRList.pps[0].pageInfo.list;
          }
        }
      });
    },
    async operateCallback(obj) {
      let {
        type,
        id,
        val,
        pipInfo
      } = obj;
      if (type == 'muteVideo') {
        if (id == this.userInfo.rtilCode) {
          if (val && this.State.anAvailbleDeviceId) {
            this.State.showInitCameraTips = true;
            this.$set(this.State.cameraStatus, this.userInfo.rtilCode, true);
          } else {
            controlCamera(this.rtc, this.devicesInfo, val);
          }
        }
        if (this.rtilCodeKeyTypeVal[id] && (this.rtilCodeKeyTypeVal[id] == 'T' || this.rtilCodeKeyTypeVal[id] == 'R')) {
          const info = {
            partyCode: this.userInfo.joinCode,
            rtilCode: id,
            value: val,
            type: 'video'
          };
          controlDeviceAudioOrVideo(info);
          return;
        }
        const params = {
          senderRtilCode: this.userInfo.rtilCode,
          type: 'camera',
          value: val,
          partyCode: this.userInfo.realPartyCode,
          toRtilCode: id,
          origin: 'interview'
        };
        controlDeviceBehavior(params);
      } else if (type === 'muteAudio') {
        if (id == this.userInfo.rtilCode) {
          let operationResult = 'success';
          if (this.rtc._localAudioTrack) {
            const type = val ? 'publish' : 'unpublish';
            operationResult = await controlDevicePublish(this.rtc, type, [this.rtc._localAudioTrack]);
          } else {
            // 初始化的时候没有本地音频轨道，需要重新获取
            controlAudio(this.rtc, this.devicesInfo, val, result => {
              if (result == 'failed') operationResult = 'failed';
            });
          }
          if (operationResult === 'success') {
            controlDeviceBehavior({
              senderRtilCode: this.userInfo.rtilCode,
              type: 'mic',
              value: val,
              partyCode: this.userInfo.realPartyCode,
              toRtilCode: this.userInfo.rtilCode,
              origin: 'interview'
            });
            // 恢复听自己声音功能
            if (val && this.hearSelf && this.userInfo.rtilCode && this.State.micStatus[this.userInfo.rtilCode] && !this.State.isMute) {
              this.rtc && this.rtc.play(this.rtc._localAudioTrack, '', {
                type: 'audio'
              });
            }
          }
        } else {
          if (this.rtilCodeKeyTypeVal[id] && (this.rtilCodeKeyTypeVal[id] == 'T' || this.rtilCodeKeyTypeVal[id] == 'R')) {
            const info = {
              partyCode: this.userInfo.joinCode,
              rtilCode: id,
              value: val,
              type: 'audio'
            };
            controlDeviceAudioOrVideo(info);
            return;
          }
          controlDeviceBehavior({
            senderRtilCode: this.userInfo.rtilCode,
            type: 'mic',
            value: val,
            partyCode: this.userInfo.realPartyCode,
            toRtilCode: id,
            origin: 'interview'
          });
        }
      } else if (type == 'editTagName') {
        this.editTagName(obj);
      } else if (type == 'moveParty') {
        id = String(id);
        const _this = this;
        this.$set(this.movePartyInfo, 'isIncludePack', false);
        if (obj.sign == 'batch') {
          // 批量
          if (obj.status) {
            if (!_this.batchMovePartyInfo.rtilCodes.includes(id)) {
              _this.batchMovePartyInfo.rtilCodes.push(id);
            }
          } else {
            this.batchMovePartyInfo.rtilCodes = this.batchMovePartyInfo.rtilCodes.filter(v => v != id);
          }
          _this.State.v3List.forEach(item => {
            if (_this.batchMovePartyInfo.rtilCodes.includes(item.rtilCode + '')) {
              _this.$set(this.movePartyInfo, 'isIncludePack', true);
            }
          });
        } else {
          this.movePartyInfo.show = true;
          this.movePartyInfo.rtilCodes = [String(id)];
          this.State.v3List.forEach(item => {
            if (this.movePartyInfo.rtilCodes.includes(item.rtilCode + '')) {
              this.$set(this.movePartyInfo, 'isIncludePack', true);
            }
          });
        }
      } else if (type == 'startPrivateConversation' || type == 'cancelPrivateConversation') {
        this.privateConversationFn(obj, 'sendRemark');
      } else if (type === 'fullScreen') {
        this.State.fullScreen = val;
        this.$set(this.fullScreenInfo, id, val);
        if (val & getFullscreenEnabled()) {
          var _document, _document$documentEle, _document$documentEle2;
          (_document = document) === null || _document === void 0 ? void 0 : (_document$documentEle = _document.documentElement) === null || _document$documentEle === void 0 ? void 0 : (_document$documentEle2 = _document$documentEle.requestFullscreen) === null || _document$documentEle2 === void 0 ? void 0 : _document$documentEle2.call(_document$documentEle);
        }
      } else if (type == 'switchFullScreen') {
        if (!val && pipInfo.id == this.leftRightRtilCode && this.rtc && pipInfo.id != this.outputRtilCode && this.State.audioType == 1) {
          this.channels[pipInfo.id].hasUnsubscribe = true;
        }
        if (pipInfo.id == this.outputRtilCode) {
          this.leftRightShareRtilCode = '';
        } else {
          val ? this.leftRightShareRtilCode = pipInfo.id : this.leftRightShareRtilCode = '';
        }
        this.leftRightRtilCode = val ? pipInfo.id : '';
        this.State.commonHostLeftRight = val;
        this.handleRtilCodeList();
        // 延迟为了防止结构没有加载
        const _this = this;
        setTimeout(() => {
          var _this$$refs$pgm;
          (_this$$refs$pgm = _this.$refs.pgm) === null || _this$$refs$pgm === void 0 ? void 0 : _this$$refs$pgm.changeFullScreenVal(val);
          if (pipInfo.id == this.leftRightRtilCode && this.rtc && val) {
            this.channels[pipInfo.id].hasUnsubscribe = false;
          }
        }, 500);
      } else if (type === 'changeParticipantMedia') {
        if (!this.rtcLoaded) {
          this.$t('commonPartyHost.switchDeviceFailed');
          return;
        }
        const params = {
          partyCode: this.State.partyCode,
          module: 'notify',
          msg: {
            key: 'changeParticipantMedia',
            rtilCode: id,
            origin: 'host',
            type: val.type,
            deviceId: val.deviceId,
            email: this.State.loginInfo.userName
          }
        };
        this.axios.post('/partyline-backend/party/noLogin/command?key=27994', params).then(async res => {
          if (!this.allowedList[id]) {
            this.$message.success(this.$t('common.sendMediaRequest'));
          }
          // 同步更新下拉框所选择的内容
          Object.keys(this.otherMediaInfo).forEach(listRtilCode => {
            if (listRtilCode == val.rtilCode) {
              if (val.type === 'video') {
                this.$set(this.otherMediaInfo[listRtilCode], 'cameraId', val.deviceId);
              } else {
                this.$set(this.otherMediaInfo[listRtilCode], 'microphoneId', val.deviceId);
              }
            }
          });
        });
      } else if (type === 'audioContext') {
        this.localVolume = val;
      } else if (type === 'setting') {
        this.deviceDetailInfo.show = true;
        this.detailObj = obj;
      } else if (type === 'mainwindow') {
        this.controlMainwindow(id);
      } else if (type == 'changeMobileMedia') {
        const params = {
          partyCode: Number(this.partyCode),
          rtilCode: id,
          peerId: this.anyWherePeerIds[id]
        };
        if (val.type == 'video') {
          var _this$anyWhereSetting, _this$anyWhereSetting2;
          params.setting = {
            key: (_this$anyWhereSetting = this.anyWhereSettings[id]) !== null && _this$anyWhereSetting !== void 0 && _this$anyWhereSetting.videoDeviceList ? 'switchVideoSource' : 'switchCamera',
            value: JSON.stringify({
              [(_this$anyWhereSetting2 = this.anyWhereSettings[id]) !== null && _this$anyWhereSetting2 !== void 0 && _this$anyWhereSetting2.videoDeviceList ? 'deviceID' : 'position']: val.deviceId
            })
          };
        } else {
          params.setting = {
            key: 'switchAudioSource',
            value: JSON.stringify({
              deviceID: val.deviceId
            })
          };
        }
        this.axios.post('/partyline-backend/anywhere/setting', params).then(res => {
          if (res.data.errorCode == '0x0') {
            this.$message({
              type: 'success',
              message: this.$t('commonFunction.operateSuccessful')
            });
          } else {
            this.$message({
              type: 'error',
              message: res.data.errorMessage
            });
          }
        }).catch(() => {
          this.$message({
            type: 'error',
            message: error.response.data.errorMessage
          });
        });
      }
    },
    changeSourceList(ccRlist) {
      ccRlist.forEach((item, index) => {
        if (!this.sourceIdKeyList.includes(item.peerId)) {
          this.sourceIdList.push(item.peerId);
        }
      });
    },
    handleRtilCodeList() {
      let codeList = JSON.parse(JSON.stringify(this.allRtilList));
      // 删除后台推送的 host RtilCode
      codeList = codeList.filter(v => v != this.userInfo.rtilCode);
      this.rtilCodeList = codeList;
    },
    getAllInterView() {
      this.axios.post('/partyline-backend/interview/noLogin/queryInterviewSlot', {
        partyCode: this.partyCode
      }).then(res => {
        if (res.data.errorCode == '0x0') {
          const list = res.data.result;
          if (list.length == 0) return;
          // 添加顶部私聊按钮
          const originConnections = {};
          this.communicationUnits.forEach(unit => {
            originConnections[unit.slotNum] = unit.connectedTo;
          });
          this.communicationUnits = list.map(v => {
            const connectedTo = originConnections[v.slotNum] || [];
            return {
              ...v,
              connectedTo
            };
          });
          // host控制与会者私聊状态
          this.initHostActiveConnections();
          // host控制与会者之间私聊状态
          this.initActiveConnections();
        }
      }).catch(e => {
        console.log(e);
      });
    },
    getOnlineMember() {
      this.axios.get('/partyline-backend/commonParty/noLogin/getViewRtilCodes', {
        params: {
          partyCode: this.partyCode
        }
      }).then(res => {
        if (res.data.errorCode == '0x0') {
          var _res$data$result$view;
          const list = (_res$data$result$view = res.data.result.viewPosition) === null || _res$data$result$view === void 0 ? void 0 : _res$data$result$view.total;
          if (!list) return;
          this.allRtilList = list.map(v => {
            if (!this.channels[v]) {
              this.$set(this.channels, v, {
                id: v,
                channel: this.partyCode
              });
            }
            this.getNickName(v);
            return v;
          });
          this.handleRtilCodeList();
        }
      }).catch(e => {
        console.log(e);
      });
    },
    async getVideoType(payload) {
      this.axios.post(`/partyline-backend/member/queryByRtilCode/${payload.id}`).then(res => {
        if (!res) return;
        if (res.data.errorCode === '0x0') {
          var _result$accountId;
          const result = res.data.result;
          const accountId = (_result$accountId = result.accountId) === null || _result$accountId === void 0 ? void 0 : _result$accountId.toLowerCase();
          const type = returnSourceType(result, this.outputRtilCode, payload.id);
          this.$set(this.rtilCodeKeyTypeVal, payload.id, type);
          this.$set(this.deviceType, payload.id, result.deviceType);
          this.$set(this.State.deviceTypeMap, payload.id, type);
          this.$set(this.devicePlatform, payload.id, result.devicePlatform);
          result.devicePeerId && this.$set(this.devicePeerIdInfo, result.devicePeerId, payload.id);
          this.$set(this.devicePeerId, payload.id, result.devicePeerId);
          // 判断是不是share的code,获取nickName
          let shareInitiator = '';
          let shareCode = '';
          const canSave = this.canSaveToGlobal(type, payload.id);
          if (canSave) {
            this.State.allRtilCodes.push(payload.id);
          }
          if (accountId.indexOf('_sharescreen') > -1) {
            // 获取是谁发起的share的code
            shareCode = payload.id;
            shareInitiator = accountId.split('_sharescreen')[0];
            this.$set(this.rtilCodeByShare, shareInitiator, shareCode);
            this.getNickName(shareInitiator, payload.id);
            this.handleRtilCodeList();
            // 初始化时接口返回慢于 Agora 推送消息会导致显示 audio-only 状态
            const _this = this;
            if (this.channels[shareCode]) {
              if (this.State.audioType || this.State.audioType == 2) {
                if (_this.State.checkShareScreen) {
                  _this.channels[shareCode].hasUnsubscribe = false;
                }
              }
            }
          } else {
            this.getNickName(payload.id, '');
          }

          // 为了live时，找出rtilcode与account的一一对应关系
          if (!result.deviceType || type === 'R') {
            var _res$data$result$acco, _res$data$result$acco2;
            this.allRtilCodeByAccountId[(_res$data$result$acco = res.data.result.accountId) === null || _res$data$result$acco === void 0 ? void 0 : _res$data$result$acco.toLowerCase()] = payload.id;
            this.allAccountIdByRtilCode[payload.id] = (_res$data$result$acco2 = res.data.result.accountId) === null || _res$data$result$acco2 === void 0 ? void 0 : _res$data$result$acco2.toLowerCase();
          }
          if (result.deviceType === 'T' || type === 'R') {
            if (!this.sourceIdList.includes(accountId)) {
              this.sourceIdList.push(accountId);
            }
            if (!this.sourceIdKeyList.includes(accountId)) {
              this.sourceIdKeyList.push(accountId);
            }
          }
          if (type === 'R') {
            if (this.channels[payload.id]) {
              this.$set(this.channels[payload.id], 'devicePeerId', result.devicePeerId);
              this.$set(this.channels[payload.id], 'info', result);
            }
            this.$set(this.channels[payload.id], 'channel', payload.channel);
            // test pgm video
            this.State.pgmStream = payload;
            this.selectPGMRid = accountId;
          }
          if (!this.State.deviceInfo[payload.id]) {
            this.$set(this.State.deviceInfo, payload.id, result);
          }
          let obj = Object.assign({}, this.channels[payload.id]);
          obj = {
            ...payload,
            ...obj,
            tid: accountId,
            info: result,
            shareInitiator,
            shareCode
          };
          this.$set(this.channels, payload.id, obj);
        }
      });
    },
    onCopy() {
      this.$message({
        message: this.$t('copy.onCopy'),
        type: 'success'
      });
    },
    onError() {
      this.$message({
        message: this.$t('copy.onError'),
        type: 'error'
      });
    },
    getPartyInfo(partyCode, illegalPartyCode) {
      if (!partyCode) return;
      const params = {};
      if (illegalPartyCode) {
        params._illegalPartyCode = illegalPartyCode;
      }
      this.axios.get(`/partyline-backend/party/${partyCode}`, {
        params
      }).then(res => {
        if (!res) return;
        if (res.data.errorCode == '0x0') {
          const result = res.data.result;
          if (!result) return;
          // const { code, layout, column, layoutName, title, id, createTime } = result
          const {
            code,
            title,
            id,
            createTime
          } = result;
          this.userInfo = {};
          this.allRtilList = [];
          this.rtilCodeList = [];
          this.State.partyCode = partyCode;
          this.State.currentPartyInfo = result;
          this.initJoinFn(code);
          setTimeout(() => {
            Bus.$emit('changePartyAddress', {
              currentId: code,
              lastId: id,
              init: 'initAside',
              title,
              id,
              createTime
            });
          }, 500);
          handleLocalStorage('set', 'partyInfo', {
            code
          });
        }
      });
    },
    async initJoinFn(partyCode) {
      if (!partyCode || (partyCode + '').length != 12) return;
      if (this.rtc) this.rtc.leave();
      this.rtc = new AgoraClient(this.AgoraCallBack);
      // 获取nickName/rtilCode
      // await this.$store.dispatch('checkEnv', { partyCode })
      if (!this.State.checkEnv.owner && !this.State.checkEnv.coHost && this.State.participateChannelMode[this.State.checkEnv.channelModel]) {
        // 不是登录人的party，已与会者身份进入
        routerJump('preview', {
          id: partyCode
        });
        return;
      }
      // 需要先获取设备列表，并判断之前选择过的设备列表是否还存在，不存在则选择默认的
      this.devicesInfo = await this.rtc.getDevice();
      this.getBehaviorsByMemberId();
      if (!handleLocalStorage('get', 'speakerId')) {
        handleLocalStorage('set', 'speakerId', this.devicesInfo.speakerId);
      }
    },
    getBehaviorsByMemberId() {
      if (!this.partyCode.trim()) return;
      const params = {
        memberId: handleLocalStorage('get', 'memberId') || 'PL_' + new Date().getTime(),
        annotation: this.partyCode.trim(),
        keys: ['nickName']
      };
      handleLocalStorage('set', 'memberId', params.memberId);
      this.axios.post('/partyline-backend/behavior/noLogin/getListByMemberId', params).then(res => {
        if (!res) return;
        const result = res.data.result;
        if (res.data.errorCode == '0x0') {
          const {
            rtilCode,
            behaviors
          } = result;
          if (rtilCode && behaviors[rtilCode].nickName) {
            this.behaviorInfo[rtilCode] = behaviors[rtilCode].nickName;
            this.$set(this.State.globalNameInfo, rtilCode, behaviors[rtilCode].nickName);
            this.joinParty(); // 有rtilCode代表设置过nickName
          } else {
            // 直接通过join接口去添加nickName（新用户）
            routerJump('preview', {
              id: this.partyCode
            });
          }
        }
      }).catch(e => {
        console.log('getListByMemberId failed');
      });
    },
    async joinParty(behaviors) {
      if (this.State.currentPartyInfo.coHost == 2) {
        this.asParticipant = false;
      }
      const params = {
        asParticipant: this.asParticipant,
        memberId: handleLocalStorage('get', 'memberId') || 'PL_' + new Date().getTime(),
        partyCode: this.partyCode,
        role: 0,
        type: 2,
        host: true,
        behaviorKeyList: ['hearSelf', 'speaker', 'nickName', 'mic', 'camera', 'audioOnlyType', 'checkAudioMainWindow', 'checkAudioShare', 'flipVideo', 'summaryLanguage']
      };
      if (behaviors) params.behaviors = behaviors;
      this.axios.post('/partyline-backend/party/noLogin/join', params).then(async res => {
        if (res.data.errorCode === '0x0') {
          var _this$rtc6;
          const result = res.data.result;
          const {
            behavior
          } = result;
          this.rtilCode = result.rtilCode;
          this.getAllPrivate();
          this.getBookLive();
          // 判断登入账号是否为内部账号
          if ((_this$rtc6 = this.rtc) !== null && _this$rtc6 !== void 0 && _this$rtc6._AgoraRTC && JSON.stringify(this.State.checkEnv) != '{}' && this.State.checkEnv.userEmail.includes('tvunetworks') && process.env.NODE_ENV === 'production') {
            this.rtc._AgoraRTC.setLogLevel(0);
            this.rtc._AgoraRTC.enableLogUpload();
          }
          this.userInfo = result;
          this.State.partyJoinInfo = result;
          // this.State.aiBotEnable = status.voiceCommand
          this.State.audioType = behavior.audioOnlyType ? Number(behavior.audioOnlyType) : 2;
          this.translateInto = behavior.summaryLanguage ? behavior.summaryLanguage : '';
          this.State.checkMainWindow = behavior.checkAudioMainWindow !== 'false';
          this.State.checkShareScreen = behavior.checkAudioShare !== 'false';
          // this.State.audioMatrixEnable = status.audioMatrix
          // this.State.productionId = status.voiceCommandProduction
          if (!this.State.voiceCommandList.includes(result.rtilCode)) {
            this.State.voiceCommandList.push(result.rtilCode);
          }
          if (this.State.hadLoadPartyList) {
            this.State.newPageLoading = false;
          }
          if (!this.State.allRtilCodes.includes(result.rtilCode)) {
            this.State.allRtilCodes.push(result.rtilCode);
          }
          // 给cohsot提供流的名称
          this.State.participantRole = result.participantRole;
          // 传递GalleryView模式下的初始化数据
          // Bus.$emit('initOperateData', result.status)
          // result.status.volumeEffect === 0 ? this.audioLevel = true : this.audioLevel = false
          // result.status.disableTalkInvokeAm === 1 ? this.muteAmAudio = true : this.muteAmAudio = false
          // 当party不是自己的时候，需要已参会者额身份加入
          const _this = this;
          if (!result.owner && _this.State.currentPartyInfo.coHost != 2 && _this.State.currentPartyInfo.coHost != -1) {
            routerJump('participate', {
              join_id: result.joinCode
            });
            return;
          }
          this.joinParam = {
            ...result,
            memberId: params.memberId,
            partyCode: this.partyCode
          };
          // 存储host 登录过的标记
          handleLocalStorage('set', 'isHost', result.owner);
          this.getNickName(result.rtilCode);
          // 获取初始化的一些状态
          // Bus.$emit('getInitStatus', {
          //   videoQuality: result.status.videoQuality || 'low',
          //   cloudProxy: result.status.cloudProxy === 'true'
          // })
          // 初始化live的对象,目的是拿到所有rtilCode的key值，在updataStatus()进行循环判断
          if (!this.rtilCodeLiveR[result.rtilCode]) {
            this.rtilCodeLiveR[result.rtilCode] = '';
          }
          this.allRtilCodeByAccountId[params.memberId] = result.rtilCode;
          this.allAccountIdByRtilCode[result.rtilCode] = params.memberId;
          if (behavior && behavior.nickName) {
            const nickName = behavior.nickName;
            behavior.speaker = behavior.speaker !== 'false';
            behavior.camera = behavior.camera !== 'false';
            behavior.mic = behavior.mic !== 'false';
            this.joinAgoraClient(result, behavior, this.joinParam);
            this.$set(this.behaviorInfo, this.userInfo.rtilCode, nickName);
            this.$set(this.State.globalNameInfo, this.userInfo.rtilCode, nickName);
          }
          // 获取status里面的值
          // 记住初始化状态
          this.$refs.footDiv && this.$refs.footDiv.changeHearSelfValue(this.hearSelf);
          // if (status.hearThemSelf) {
          //   this.iconList.forEach(item => {
          //     if (item === 'speaker') {
          //       this.iconList.push('hearMyself')
          //     }
          //   })
          // }
          // mainWindow
          this.outputRtilCode = status.output;
          this.getAllInterView();
          this.getOnlineMember();
          // status.hearThemSelf ? this.State.startHearSelf = true : ''
          // Bus.$emit('initVFBinfo', status)
          // 是否要取消屏幕共享, 如果是调度者自己分享则需要取消，与会者分享保留状态
        } else if (res.data.errorCode === '80520111') {
          this.coHostLimit.show = true;
        }
      });
    },
    async joinAgoraClient(result, obj, param) {
      if (!this.State.pageSerBusRequestWs[this.partyCode]) {
        Bus.$emit('createWs', {
          ...this.State.config,
          partyCode: this.partyCode
        });
      }
      // join到 Agora 会议需要准备的数据
      this.State.isMute = !obj.speaker;
      this.$set(this.State.cameraStatus, result.rtilCode, this.devicesInfo.cameraId ? obj.camera : false);
      this.$set(this.State.micStatus, result.rtilCode, this.devicesInfo.microphoneId ? obj.mic : false);
      // Me设置crew功能，使用到
      this.MeInfo = {
        id: result.rtilCode,
        tid: this.loginInfo.id,
        info: {
          rtilCode: result.rtilCode
        },
        channel: this.partyCode
      };
      this.State.currentRtilCode = result.rtilCode;
      handleLocalStorage('set', 'manageRtilCode', result.rtilCode);
      handleLocalStorage('set', 'rtilCode', result.rtilCode);
      // join client
      this.getMeetingInfo(param, result);
    },
    async getMeetingInfo(param, result) {
      const {
        appId,
        tokenCode,
        rtilCode,
        partyCode,
        memberId,
        videoQualities
      } = param;
      const params = {
        appId: appId,
        channel: partyCode + '',
        token: tokenCode,
        uid: rtilCode,
        codec: 'h264',
        videoConfig: videoQualities,
        publishVideo: this.State.cameraStatus[this.userInfo.rtilCode],
        publishAudio: this.State.micStatus[this.userInfo.rtilCode],
        // 不能再根据当前是否有媒体设备来创建 track
        // 还要添加当前是否处于禁止状态
        // 极少数会出现 mute camera 了并且 camera 还被占了，这个时候创建会报错，而且会有即使 mute 了 camera 但是摄像头灯还在亮的问题
        video: !!this.devicesInfo.cameraId && this.State.cameraStatus[this.userInfo.rtilCode],
        audio: !!this.devicesInfo.microphoneId && this.State.micStatus[this.userInfo.rtilCode],
        getRemoteNetworks: true,
        // 传入用户选择的可用的音视频采集设备的id
        microphoneId: this.devicesInfo.microphoneId,
        cameraId: this.devicesInfo.cameraId,
        executeLocalSubscribe: true,
        startProxy: false
      };
      const uid = await this.rtc.join(params);
      if (uid) {
        this.rtcLoaded = true;
        this.State.controlInfo = {
          ...params,
          memberId: memberId
        };
        this.rtc._AgoraRTC.setParameter('ENABLE_FULL_LINK_AV_SYNC', true);

        // 更改hostjr userId
        const userId = rtilCode + '_' + this.behaviorInfo[this.MeInfo.id] + '_' + this.partyCode;
        this.rtc._client && this.rtc._client.enableAudioVolumeIndicator();
        window.hj && window.hj('identify', userId, {
          timeStamp: Date.now()
        });
      }
    },
    changeR({
      rtilCode,
      rid
    }) {
      this.$set(this.rtilCodeLiveR, rtilCode, rid);
    },
    async userJoin(payload) {
      this.$set(this.fullScreenInfo, payload.id, false);
      this.State.haveUnReadMessage = true;
      // 初始化live的对象,目的是拿到所有rtilCode的key值，在updataStatus()进行循环判断
      if (!this.rtilCodeLiveR[payload.id]) {
        this.rtilCodeLiveR[payload.id] = '';
      }
      if (!this.channels[payload.id]) {
        this.$set(this.channels, payload.id, {
          id: payload.id
        });
      }
      // 设置默认为device的status
      this.$set(this.State.cameraStatus, payload.id, false);
      this.$set(this.State.micStatus, payload.id, false);
      await this.getVideoType(payload);
      this.getAllInterView();
      this.sendToGetMediaInfo(payload.id);
    },
    unlinkQuality(payload) {
      if (!payload.type) return;
      this.$set(this.remoteNetWorks, payload.id, {
        uplinkNetworkQuality: payload.uplinkNetworkQuality,
        downlinkNetworkQuality: payload.downlinkNetworkQuality
      });
    },
    async AgoraCallBack({
      action,
      payload
    }) {
      var _this$rtc7, _this$rtc8, _this$rtc$_localAudio2, _this$rtc9, _this$rtc10, _this$rtc11;
      const {
        changeDevice
      } = payload;
      switch (action) {
        case 'unlinkQuality':
          this.unlinkQuality(payload);
          break;
        case 'changeDevice':
          if (payload.status === 'success') {
            handleLocalStorage('set', payload.type, payload.deviceId);
          }
          break;
        case 'user-joined':
          this.userJoin(payload);
          break;
        case 'user-left':
          this.userLeave(payload);
          break;
        case 'subscribe-track':
          this.subscribeTrack(payload);
          break;
        case 'subscribe-video':
          this.dealSubscribeVideo(payload);
          break;
        case 'user-published':
        case 'user-unpublished':
          this.userPublished(action, payload);
          break;
        case 'local-track':
          const {
            videoTrack,
            audioTrack
          } = payload;
          // Me设置私聊功能，使用到
          this.MeInfo = {
            id: this.userInfo.rtilCode,
            tid: handleLocalStorage('get', 'memberId'),
            info: {
              rtilCode: this.userInfo.rtilCode
            },
            channel: this.partyCode,
            videoTrack: videoTrack,
            audioTrack: audioTrack
          };
          const MeInfos = {
            id: this.userInfo.rtilCode,
            tid: handleLocalStorage('get', 'memberId'),
            info: {
              rtilCode: this.userInfo.rtilCode
            },
            channel: this.partyCode,
            videoTrack: videoTrack,
            audioTrack: audioTrack
          };
          this.$set(this.channels, this.userInfo.rtilCode, MeInfos);
          if ((_this$rtc7 = this.rtc) !== null && _this$rtc7 !== void 0 && _this$rtc7._localVideoTrack) {
            const videoLabel = this.rtc._localVideoTrack.getTrackLabel();
            this.devicesInfo.cameraList.forEach(item => {
              if (item.label === videoLabel) {
                this.devicesInfo.cameraId = item.deviceId;
              }
            });
            if (this.noCamera) {
              controlCamera(this.rtc, this.devicesInfo, false);
              controlDeviceBehavior({
                senderRtilCode: this.userInfo.rtilCode,
                type: 'camera',
                value: false,
                partyCode: this.userInfo.realPartyCode,
                toRtilCode: this.userInfo.rtilCode,
                origin: 'commonPartyHost'
              });
            }
          }
          if ((_this$rtc8 = this.rtc) !== null && _this$rtc8 !== void 0 && _this$rtc8._localAudioTrack) {
            const audioLabel = this.rtc._localAudioTrack.getTrackLabel();
            this.devicesInfo.microphoneList.forEach(item => {
              if (item.label === audioLabel) {
                this.devicesInfo.microphoneId = item.deviceId;
              }
            });
            // 为了是否需要听见自己的声音添加的
            if (this.startHearSelf && this.hearSelf && this.userInfo.rtilCode && this.State.micStatus[this.userInfo.rtilCode] && !this.State.isMute) {
              this.rtc && this.rtc.play(this.rtc._localAudioTrack, '', {
                type: 'audio'
              });
            }
            this.detecteMicMuted();
          }
          break;
        case 'autoPlayFailed':
          this.$confirm(this.$t('commonFunction.autoPlayFailed'), {
            confirmButtonText: this.$t('galleryHost.ok'),
            cancelButtonText: this.$t('commonFunction.cancel'),
            customClass: 'confirmBox',
            cancelButtonClass: 'cancelBtn',
            confirmButtonClass: 'joinBtn'
          }).then(() => {
            this.rtc && this.rtc.rePlay();
          }).catch(e => {
            console.log(e);
          });
          break;
        case 'local-publish':
          if (payload.type.includes('audio') && this.userInfo.rtilCode) {
            this.$set(this.State.micStatus, this.userInfo.rtilCode, true);
          }
          if (payload.type.includes('video') && this.userInfo.rtilCode) {
            this.$set(this.State.cameraStatus, this.userInfo.rtilCode, true);
          }
          break;
        case 'local-unpublish':
          if (payload.type.includes('audio') && this.userInfo.rtilCode) {
            this.$set(this.State.micStatus, this.userInfo.rtilCode, false);
          }
          if (payload.type.includes('video') && this.userInfo.rtilCode) {
            this.$set(this.State.cameraStatus, this.userInfo.rtilCode, false);
          }
          break;
        // case 'receiveMetadata':
        //   this.dealMetadata(payload)
        //   break
        case 'connection-state-change':
          // 代表有人重复加入
          if (payload.reason === 'UID_BANNED') {
            this.repeatInfo.show = true;
          }
          break;
        // case 'cameraChange':
        //   if (!this.rtc) return
        //   this.devicesInfo = this.rtc && await this.rtc.getDevice()
        //   if (this.rtc?._localVideoTrack && changeDevice.device.label === this.rtc._localVideoTrack.getTrackLabel()) {
        //     try {
        //       const oldCameras = await this.rtc._AgoraRTC.getCameras()
        //       oldCameras[0] && this.rtc.setDevice(oldCameras[0].deviceId, 'video', (returnType) => {
        //         this.devicesInfo.cameraId = oldCameras[0].deviceId
        //         returnType === 'success' ? this.$message.success(this.$t('common.autoSwitchNewCameraSuccess')) : this.$message.error(this.$t('common.autoSwitchNewCameraFailed'))
        //       })
        //     } catch (e) {
        //       console.log('get camera list failed')
        //     }
        //   }
        //   break
        case 'micChange':
          if (!this.rtc) return;
          this.devicesInfo = this.rtc && (await this.rtc.getDevice());
          console.log('devicesinfo', this.devicesInfo);
          if (((_this$rtc$_localAudio2 = this.rtc._localAudioTrack) === null || _this$rtc$_localAudio2 === void 0 ? void 0 : _this$rtc$_localAudio2._config.microphoneId) != 'default') {
            this.$message.warning(this.$t('common.micListChange'));
          }
          // 拔掉mic
          if ((_this$rtc9 = this.rtc) !== null && _this$rtc9 !== void 0 && _this$rtc9._localAudioTrack && this.rtc._localAudioTrack._deviceName.includes(changeDevice.device.label)) {
            try {
              const currentMicList = await this.rtc._AgoraRTC.getMicrophones();
              if (!currentMicList.length) return;
              const isHaveDefault = currentMicList.find(item => item.deviceId === 'default');
              this.rtc.setDevice(isHaveDefault ? 'default' : currentMicList[0].deviceId, 'audio', returnType => {
                if (returnType === 'success') {
                  this.detecteMicMuted();
                  this.$message.success(this.$t('common.autoSwitchNewMicSuccess'));
                  this.$refs.localSingleSource.controlAudioChannel();
                } else {
                  this.$message.error(this.$t('common.autoSwitchNewMicFailed'));
                }
                this.devicesInfo.microphoneId = isHaveDefault ? 'default' : currentMicList[0].deviceId;
                console.log('log: ', 'The microphone list has changed');
              });
            } catch (e) {
              console.log('get mic list failed');
            }
          } else if (changeDevice.state === 'ACTIVE' && (_this$rtc10 = this.rtc) !== null && _this$rtc10 !== void 0 && _this$rtc10._localAudioTrack && this.rtc._localAudioTrack._config.microphoneId == 'default') {
            // 如果当前使用的是 default 设备并且新加入的也是 default 设备，则切换到最新的 default 设备
            const newDeviceGroupId = changeDevice.device.groupId;
            const newDeviceIsDefault = this.devicesInfo.microphoneList.find(item => item.groupId === newDeviceGroupId && item.deviceId === 'default');
            if (newDeviceIsDefault !== null && newDeviceIsDefault !== void 0 && newDeviceIsDefault.deviceId) {
              this.rtc.setDevice('default', 'audio', returnType => {
                if (returnType === 'success') {
                  this.$message.success(this.$t('common.autoSwitchNewMicSuccess'));
                  this.$refs.localSingleSource.controlAudioChannel();
                  this.detecteMicMuted();
                } else {
                  this.$message.error(this.$t('common.autoSwitchNewMicFailed'));
                }
              });
            }
          }
          break;
        case 'playbackChange':
          if (!this.rtc) return;
          if (typeof HTMLAudioElement.prototype.setSinkId === 'undefined') {
            this.$t('common.notSupportSwitchSpeaker');
            return;
          }
          const currentSpeakerList = await this.rtc._AgoraRTC.getPlaybackDevices();
          if (changeDevice.state !== 'ACTIVE' && (_this$rtc11 = this.rtc) !== null && _this$rtc11 !== void 0 && _this$rtc11._localAudioTrack) {
            const currentDeviceId = handleLocalStorage('get', 'speakerId');
            const currentLabelArray = this.devicesInfo.speakerList.filter(item => item.deviceId == currentDeviceId);
            const haveUseDevice = currentSpeakerList.find(item => item.label == currentLabelArray[0].label);
            if (!haveUseDevice && currentSpeakerList[0]) {
              handleLocalStorage('set', 'speakerId', currentSpeakerList[0].deviceId);
              this.$nextTick(() => {
                this.rtilCodeList.forEach(rtilCode => {
                  if (this.$refs[`remoteSingleSource${rtilCode}`] && this.$refs[`remoteSingleSource${rtilCode}`][0] && rtilCode != this.outputRtilCode) {
                    this.$refs[`remoteSingleSource${rtilCode}`][0].setSpeaker();
                  }
                });
              });
              this.devicesInfo.speakerId = currentSpeakerList[0].deviceId;
            }
          }
          this.devicesInfo.speakerList = currentSpeakerList;
          break;
      }
    },
    getDeviceDatailByRtilCode(payload) {
      const {
        id,
        channel
      } = payload;
      if (!id || !channel) return;
      const params = {
        rtilCode: id,
        keys: ['nickName'],
        partyCode: this.partyInfo.joinCode
      };
      axios.post('/partyline-backend/receiver/noLogin/queryDeviceDetail', params).then(res => {
        if (res.data.errorCode === '0x0') {
          const stationInfo = res.data.result;
          if (!stationInfo) return;
          const rtilCode = stationInfo.rtilCode;
          const deviceType = returnSourceType(stationInfo, '', rtilCode);
          stationInfo.email = '';
          stationInfo.emailList = [];
          this.$set(this.nickNameMap, rtilCode, stationInfo.nickName);
          this.$set(this.deviceType, rtilCode, deviceType);
          switch (deviceType) {
            case 'App':
            case 'T':
              const isHaveAddT = this.talentList.find(item => item.rtilCode == id);
              if (isHaveAddT) return;
              this.talentList.push(stationInfo);
              this.allTalentList.push(stationInfo);
              break;
            case 'R':
              const isHaveAddR = this.State.stationList.find(item => {
                return item.rtilCode == Number(id);
              });
              // 防止重复添加
              if (!isHaveAddR) {
                this.stationList.push(stationInfo);
                this.allStationList.push(stationInfo);
                this.State.stationList.push(stationInfo);
              }
              break;
          }
          this.allRtilCode.push(stationInfo);
          this.stationList.forEach(item => {
            if (item.rtilCode == id) {
              item.online = true;
            }
          });
        }
      });
    },
    subscribeTrack(payload) {
      try {
        var _this$myselfMuteInfo$;
        const {
          id,
          videoTrack,
          audioTrack
        } = payload;
        // 上报状态
        // this.reportUserChange(payload, 'addView')
        // 列表流的显示
        // 如果是自己的屏幕分享则不去订阅
        if (this.State.localShareInfo[id]) return;
        const obj = Object.assign({}, this.channels[payload.id]);
        obj.id = payload.id;
        obj.videoTrack = videoTrack;
        obj.audioTrack = audioTrack;
        if (JSON.stringify(this.myselfMuteInfo) != '{}' && this.State.audioMatrixEnable && (_this$myselfMuteInfo$ = this.myselfMuteInfo.muteRtilCodes) !== null && _this$myselfMuteInfo$ !== void 0 && _this$myselfMuteInfo$.includes(id)) {
          var _this$rtc12;
          // 首先判断是否处于私聊状态,在私聊的状态可以不受 host audio matrix 的控制
          obj.muteByAudioMatrix = true;
          (_this$rtc12 = this.rtc) === null || _this$rtc12 === void 0 ? void 0 : _this$rtc12.unsubscribe(id, 'audio');
        }
        this.$set(this.channels, payload.id, obj);
      } catch (error) {}
    },
    footCallback(info) {
      const {
        type,
        val
      } = info;
      switch (type) {
        case 'controlAudio':
          this.mic = val;
          this.rtc.setEnabled(val, 'audio');
          const partyInfo = this.partyInfo;
          controlDeviceBehavior({
            senderRtilCode: partyInfo.rtilCode,
            type: 'mic',
            value: val,
            partyCode: partyInfo.joinCode,
            toRtilCode: partyInfo.rtilCode,
            origin: 'intercom',
            notChangeStatus: true
          });
          break;
        case 'controlSpeaker':
          this.speaker = val;
          this.State.speaker = val;
          changeBehaviorStatus({
            key: 'speaker',
            rtilCode: this.partyInfo.rtilCode,
            realPartyCode: this.partyInfo.joinCode,
            value: val
          });
          break;
        case 'changeDevice':
          this.switchDevice(val);
          break;
        case 'controlTalkToAllTalents':
          const isQuicklyOperation = this.isQuickluOperation();
          if (isQuicklyOperation) return;
          this.State.intercomTalkToAllTalents = !this.State.intercomTalkToAllTalents;
          this.sendTalkToAllTalents(this.State.intercomTalkToAllTalents);
          break;
        case 'changeNickName':
          this.$set(this.nickNameMap, this.partyInfo.rtilCode, val);
          break;
      }
    },
    async getNickName(id, key) {
      if (!id || !this.partyCode && !this.State.partyCode) return;
      await this.axios.post('/partyline-backend/behavior/noLogin/getList', {
        originRtilCode: this.userInfo.rtilCode,
        annotation: this.partyCode || this.State.partyCode,
        keys: ['avatar', 'nickName', 'tagName', 'talkBack', 'camera', 'mic', 'blockAudio', 'blockVideo', 'flipVideo'],
        marks: [id]
      }).then(res => {
        if (res.data.errorCode === '0x0') {
          const result = res.data.result[id];
          const rtilCode = key || id;
          this.$set(this.degreeHost, id, result.flipVideo);
          this.$set(this.behaviorInfo, rtilCode, result.nickName);
          // pip头像相关
          this.$set(this.avatarInfo, rtilCode, result.avatar);
          this.isNotLoginArray = Object.keys(this.avatarInfo).filter(key => this.avatarInfo[key] === null);
          if (id == this.userInfo.rtilCode && result.voipRid) {
            this.needStartVoip = true;
            this.$set(this.voipSourceIdList, id, result.voipSourceId);
          }
          this.$set(this.voipInfo, id, result.voipRid);
          this.$set(this.tagNameInfo, id, result.tagName);
          // 判断 host 是否可以 voice command
          if (result.voiceCommand !== 'true' && id == this.userInfo.rtilCode) {
            this.State.voiceCommandList = this.State.voiceCommandList.filter(rtilCode => {
              return rtilCode != id;
            });
          }
        }
      }).catch(e => {
        console.log('getList failed');
      });
    },
    switchDevice(info) {
      const {
        type,
        deviceId
      } = info;
      if (type === 'speaker') {
        handleLocalStorage('set', 'speakerId', deviceId);
      } else {
        this.rtc.setDevice(deviceId, type, result => {
          if (result === 'success') {
            this.$message.success(this.$t('common.switchMicSuccess'));
          } else {
            this.$message.warning(this.$t('common.switchMicFailed'));
          }
        });
      }
    },
    isQuickluOperation() {
      const currentTime = new Date().getTime();
      if (currentTime - this.lastOperationTime < 500) {
        return true;
      } else {
        this.lastOperationTime = currentTime;
        return false;
      }
    },
    leave(id) {
      this.allRtilCode = this.allRtilCode.filter(item => item.rtilCode != id);
      this.talentList = this.talentList.filter(info => info.rtilCode != id);
      this.stationList.forEach(item => {
        if (item.rtilCode == id) {
          item.online = false;
        }
      });
      this.State.stationList = this.State.stationList.filter(item => item.rtilCode != id);
    }
  },
  beforeRouteLeave(to, from, next) {
    var _this$rtc13, _this$socket;
    (_this$rtc13 = this.rtc) === null || _this$rtc13 === void 0 ? void 0 : _this$rtc13.leave();
    window.removeEventListener('resize', this.changeLayout);
    (_this$socket = this.socket) === null || _this$socket === void 0 ? void 0 : _this$socket.close();
    if (this.wsPageSTimer) clearInterval(this.wsPageSTimer);
    next();
  }
};